<template>
<!--   <input
    type="text"
    name=""
    v-model="text"
    v-debounce:500ms="search"
  > -->
  <v-text-field
    v-model="text"
    v-debounce:500ms="search"
    :placeholder="placeholder"
    filled
    rounded
    dense
    prepend-inner-icon="search"
    clearable
    color="black"
    full-width
    hide-details
    style="align-self: center;"
  ></v-text-field>
</template>

<style scoped>
  >>> .v-input__slot {
    padding: 0px 12px !important;
  }
  >>> .v-input__prepend-inner {
    padding-right: 6px !important;
  }
  >>> input {
    padding: 0px !important;
  }
  >>> .v-input__prepend-inner {
    margin-top: 8px !important;
  }
</style>

<script>
export default {
  name: 'SearchBox',
  props: {
    placeholder: {
      type: String,
      default: '',
      required: false,
    },
  },
  data: () => ({
    text: '',
  }),
  methods: {
    search() {
      this.$store.dispatch('search/search', this.text);
      this.$track('search', 'search', this.text);
    },
  },
};
</script>
